<template>
  <a-modal
    :visible="ShowPanel"  :mask="false" width="50%"
    title="新增收益数据"
    @ok="handleOk()"
    @cancel="handleCancel()">
    <a-form >
      <a-form-item label="月份" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-date-picker
          style="width: 200px;"
          v-model="addForm.date"
          valueFormat="YYYY-MM" />
      </a-form-item>
      <a-form-item label="渠道" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-input style="width: 200px;" v-model="addForm.channel"></a-input>
      </a-form-item>
      <a-form-item label="收益" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-input-number style="width: 200px;" v-model="addForm.revenue"></a-input-number>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {AddRevenueSelf} from "../../../api/v1/revenue_self_api";

export default {
  name: "AddPanel",
  props:['ShowPanel','ChannelList'],
  data(){
    return {
      addForm:{
        app_id:0,
        channel:'',
        date:'',
        revenue:0,
      },
      tableColumns3:[
        { title: '国家', dataIndex: 'country',align:'center'},
        { title: '花费', dataIndex: 'spend', scopedSlots: { customRender: 'spend' },align:'center'},
        { title: '安装', dataIndex: 'installs', scopedSlots: { customRender: 'installs' },align:'center'},
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' },align:'center'},
      ],
    }
  },
  watch:{
    'ShowPanel':{
      handler:function (newVal,oldVal){
        this.addForm = {
          revenue:0,
          channel:'',
          date:'',
          app_id:this.$store.getters.getAppId
        }
      }
    }
  },
  methods:{
    handleOk(){
      AddRevenueSelf(this.addForm).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Revenue/Self/AddPanel.vue